import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { approveTemplateDetails, deleteTemplateDetails, editTemplateApprovalDetails, editTemplateDetails, getRejectedTemplateDetails, getTemplateDetails, rejectTemplateDetails, saveTemplateApprovalDetails, saveTemplateDetails } from "../../../services/studentService"

const initialState = {
    saveTemplateDetails: {
      status: "idle",
      error: null,
      message: ''
    },
    getTemplateDetails: {
      status: "idle",
      error: null,
      data: []
    },
    getRejectedTemplateDetails: {
      status: "idle",
      error: null,
      data: []
    },
    deleteTemplateDetails: {
      status: "idle",
      error: null,
      message: ''
    },
    editTemplateDetails: {
      status: "idle",
      error: null,
      message: ''
    },
    saveTemplateApprovalDetails: {
        status: "idle",
        error: null,
        message: '' 
    },
    editTemplateApprovalDetails: {
        status: "idle",
        error: null,
        message: '' 
    },
    approveTemplateDetails: {
        status: "idle",
        error: null,
        message: '' 
    },
    rejectTemplateDetails: {
        status: "idle",
        error: null,
        message: '' 
    }
}

export const saveTemplate = createAsyncThunk(
    "template/saveTemplate",
    async (data) => {
      const response = await saveTemplateDetails(data)
      return response
    }
)

export const getTemplates = createAsyncThunk(
    "template/getTemplates",
    async (data) => {
        const response = await getTemplateDetails(data)
        return response
    }
)

export const getRejectedTemplates = createAsyncThunk(
    "template/getRejectedTemplates",
    async(data) => {
        const response = await getRejectedTemplateDetails(data)
        return response
    }
)
  
export const deleteTemplate = createAsyncThunk(
    "template/deleteTemplate",
    async (data) => {
        const response = await deleteTemplateDetails(data)
        return response
    }
)

export const editTemplate = createAsyncThunk(
    "template/editTemplate",
    async (data) => {
        const response = await editTemplateDetails(data)
        return response
    }
)

export const saveTemplateApproval = createAsyncThunk(
    "template/saveTemplateApproval",
    async (data) => {
        const response = await saveTemplateApprovalDetails(data)
        return response
    }
)

export const editTemplateApproval = createAsyncThunk(
    "template/editTemplateApproval",
    async (data) => {
        const response = await editTemplateApprovalDetails(data)
        return response
    }
)

export const approveTemplate = createAsyncThunk(
    "template/approveTemplate",
    async (data) => {
        const response = await approveTemplateDetails(data)
        return response
    }
)

export const rejectTemplate = createAsyncThunk(
    "template/rejectTemplate",
    async (data) => {
        const response = await rejectTemplateDetails(data)
        return response
    }
)


export const templateSlice = createSlice({
    name: "template",
    initialState,
    reducers: {
        resetSaveTemplateState: (state) => {
            state.saveTemplateDetails = initialState.saveTemplateDetails
        },
        resetEditTemplateState: (state) =>{
            state.editTemplateDetails = initialState.editTemplateDetails
        },
        resetSaveTemplateApprovalDetailsState: (state) => {
            state.saveTemplateApprovalDetails = initialState.saveTemplateApprovalDetails
        },
        resetEditTemplateApprovalDetailsState: (state) => {
            state.editTemplateApprovalDetails = initialState.editTemplateApprovalDetails
        }
    },
    extraReducers: {
      [saveTemplate.pending]: (state) => {
        state.saveTemplateDetails.status = "loading"
      },
      [saveTemplate.fulfilled]: (state, action) => {
        if(action.payload.message && !action.payload.isAlreadyExits) {
          state.saveTemplateDetails.status = 'succeeded'
          state.saveTemplateDetails.message = action.payload.message
        }else{
          state.saveTemplateDetails.status = "failed"
          state.saveTemplateDetails.message = action.payload.message
        }
      },
      [saveTemplate.rejected]: (state, action) => {
        state.saveTemplateDetails.status = "failed"
        state.saveTemplateDetails.error = action.error.message
      },

      [getTemplates.pending]: (state) => {
        state.getTemplateDetails.status = "loading"
      },
      [getTemplates.fulfilled]: (state, action) => {
        if(action.payload) {
          state.getTemplateDetails.status = 'succeeded'
          state.getTemplateDetails.data = action.payload
        }else{
          state.getTemplateDetails.status = "failed"
          state.getTemplateDetails.error = "No records found"
        }
      },
      [getTemplates.rejected]: (state, action) => {
        state.getTemplateDetails.status = "failed"
        state.getTemplateDetails.error = action.error.message
      },

      [getRejectedTemplates.pending]: (state) => {
        state.getRejectedTemplateDetails.status = "loading"
      },
      [getRejectedTemplates.fulfilled]: (state, action) => {
        if(action.payload) {
          state.getRejectedTemplateDetails.status = 'succeeded'
          state.getRejectedTemplateDetails.data = action.payload
        }else{
          state.getRejectedTemplateDetails.status = "failed"
          state.getRejectedTemplateDetails.error = "No records found"
        }
      },
      [getRejectedTemplates.rejected]: (state, action) => {
        state.getRejectedTemplateDetails.status = "failed"
        state.getRejectedTemplateDetails.error = action.error.message
      },

      [deleteTemplate.pending]: (state) => {
        state.deleteTemplateDetails.status = "loading"
      },
      [deleteTemplate.fulfilled]: (state, action) => {
        if(action.payload.message) {
          state.deleteTemplateDetails.status = 'succeeded'
          state.deleteTemplateDetails.message = action.payload.message
        }else{
          state.deleteTemplateDetails.status = "failed"
          state.deleteTemplateDetails.error = "Some Technical Issue"
        }
      },
      [deleteTemplate.rejected]: (state, action) => {
        state.deleteTemplateDetails.status = "failed"
        state.deleteTemplateDetails.error = action.error.message
      },

      [editTemplate.pending]: (state) => {
        state.editTemplateDetails.status = "loading"
      },
      [editTemplate.fulfilled]: (state, action) => {
        if(action.payload.message && !action.payload.isAlreadyExits) {
            state.editTemplateDetails.status = 'succeeded'
            state.editTemplateDetails.message = action.payload.message
          }else{
            state.editTemplateDetails.status = "failed"
            state.editTemplateDetails.message = action.payload.message
          }
      },
      [editTemplate.rejected]: (state, action) => {
        state.editTemplateDetails.status = "failed"
        state.editTemplateDetails.error = action.error.message
      },

      [saveTemplateApproval.pending]: (state) => {
        state.saveTemplateApprovalDetails.status = "loading"
      },
      [saveTemplateApproval.fulfilled]: (state, action) => {
        if(action.payload.message && !action.payload.isAlreadyExits) {
          state.saveTemplateApprovalDetails.status = 'succeeded'
          state.saveTemplateApprovalDetails.message = action.payload.message
        }else{
          state.saveTemplateApprovalDetails.status = "failed"
          state.saveTemplateApprovalDetails.message = action.payload.message
        }
      },
      [saveTemplateApproval.rejected]: (state, action) => {
        state.saveTemplateApprovalDetails.status = "failed"
        state.saveTemplateApprovalDetails.error = action.error.message
      },

      [editTemplateApproval.pending]: (state) => {
        state.editTemplateApprovalDetails.status = "loading"
      },
      [editTemplateApproval.fulfilled]: (state, action) => {
        if(action.payload.message && !action.payload.isAlreadyExits) {
          state.editTemplateApprovalDetails.status = 'succeeded'
          state.editTemplateApprovalDetails.message = action.payload.message
        }else{
          state.editTemplateApprovalDetails.status = "failed"
          state.editTemplateApprovalDetails.message = action.payload.message
        }
      },
      [editTemplateApproval.rejected]: (state, action) => {
        state.editTemplateApprovalDetails.status = "failed"
        state.editTemplateApprovalDetails.error = action.error.message
      },

      [approveTemplate.pending]: (state) => {
        state.approveTemplateDetails.status = "loading"
      },
      [approveTemplate.fulfilled]: (state, action) => {
        if(action.payload.message) {
          state.approveTemplateDetails.status = 'succeeded'
          state.approveTemplateDetails.message = action.payload.message
        }else{
          state.approveTemplateDetails.status = "failed"
          state.approveTemplateDetails.error = "Some Technical Issue"
        }
      },
      [approveTemplate.rejected]: (state, action) => {
        state.approveTemplateDetails.status = "failed"
        state.approveTemplateDetails.error = action.error.message
      },

      [rejectTemplate.pending]: (state) => {
        state.rejectTemplateDetails.status = "loading"
      },
      [rejectTemplate.fulfilled]: (state, action) => {
        if(action.payload.message) {
          state.rejectTemplateDetails.status = 'succeeded'
          state.rejectTemplateDetails.message = action.payload.message
        }else{
          state.rejectTemplateDetails.status = "failed"
          state.rejectTemplateDetails.error = "Some Technical Issue"
        }
      },
      [rejectTemplate.rejected]: (state, action) => {
        state.rejectTemplateDetails.status = "failed"
        state.rejectTemplateDetails.error = action.error.message
      },
    }
  })
  
  export const { resetSaveTemplateState, resetEditTemplateState, resetSaveTemplateApprovalDetailsState, resetEditTemplateApprovalDetailsState } = templateSlice.actions
  
  export default templateSlice.reducer